import FlightStatusHeader from './FlightStatusHeader';

export default FlightStatusHeader;
